import { useState, useEffect } from 'react';
import algoliasearch from 'algoliasearch';

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_INDEX,
  process.env.GATSBY_ALOGLIA_KEY
);

const useAlgolia = (indexName, query) => {
  const [searchResponse, setSearchResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query) {
      setSearchResponse(null);
      return;
    }

    const fetchResults = async () => {
      setLoading(true);
      setError(null);

      try {
        const index = algoliaClient.initIndex(indexName);
        const response = await index.search(query);
        setSearchResponse(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [indexName, query]);

  return {
    searchResponse,
    loading,
    error,
  };
};

export default useAlgolia;
